import React from 'react';
import propTypes from 'prop-types';
import classNames from 'classnames';

import { scriptConfigViews } from 'constants/values';

// Components
import ScriptConfigContainer from 'edit/ScriptConfigContainerConnect';
import ScriptSummaryContainer from 'edit/ScriptSummaryConnect';
import ZonesContainer from 'edit/ZonesContainerConnect';

let zones = {};
let scriptConfigContainer, scrollWrapper;
const baseString = 'vra-edit-display-panel';
const classString = classNames({
  [`${baseString}`]: true,
  'vra-display-panel-content': true
});
let EditDisplayPanel = ({
  scriptConfigView,
  selectedZoneIds,
  shouldScrollToSelectedZone
}) => {

  if (shouldScrollToSelectedZone) {
    const selectedZoneDOMElement = zones[selectedZoneIds[0]];
    if (selectedZoneDOMElement) {
      const topMarginToSelectedZone = selectedZoneDOMElement.offsetTop;
      const scriptConfigContainerHeight = scriptConfigContainer.getBoundingClientRect().height;
      scrollWrapper.scrollTop = scriptConfigContainerHeight + topMarginToSelectedZone;
    }
  }

  return (
    <section
      className={classString}
      data-test-id={baseString}>
      <section
        className={`${baseString}__scroll-wrapper`}
        ref={(e) => { scrollWrapper = e; }}>
        <header ref={(e) => { scriptConfigContainer = e; }}>
          <ScriptConfigContainer />
        </header>
        {
          scriptConfigView === scriptConfigViews.SUMMARY
          && <ZonesContainer zoneRef={(e, zoneId) => { if (zoneId) { zones[zoneId] = e; } }} />
        }
      </section>

      <footer>
        <ScriptSummaryContainer />
      </footer>
    </section>
  );
};
EditDisplayPanel.propTypes = {
  scriptConfigView: propTypes.string.isRequired,
  selectedZoneIds: propTypes.array.isRequired,
  shouldScrollToSelectedZone: propTypes.bool.isRequired
};
export default EditDisplayPanel;
